export enum UserEventType {
  CLICK = 'click',
  KEYDOWN = 'keydown',
  ERROR = 'error',
  DROP = 'drop',
  CONNECT = 'connect',
}

export enum EventControlComponent {
  PREDICTIONS_TABLE = 'predictions-table',
  PIPELINE_FEEDBACK_TABLE = 'pipeline-feedback-table',
  LOGIN = 'login',
  PIPELINE_TEMPLATE = 'pipeline-template',
  GROUNDEDNESS = 'groundedness',
  PRICING = 'pricing',
  SEARCH_RESULT = 'search-result',
  REFERENCE_DRAWER = 'reference-drawer',
  QUERY_DETAILED_DRAWER = 'query-detailed-drawer',
  STUDIO = 'studio',
  STUDIO_INDEXES = 'studio-indexes',
  INDEXES_FILES = 'indexes-files',
  API_KEYS = 'api-keys',
  ROLES = 'roles',
}

export enum EventControlPricingElement {
  INTERESTED = 'interested',
  SUBMITS_INTEREST = 'submits-interest',
}

export enum EventControlElement {
  DOWNLOAD = 'download',
  NODE_TAB = 'node-tab',
  FILTERS = 'filters',
  SELECT = 'select',
  TAB = 'tab',
}

export enum EventControlDataTableElement {
  SEARCH = 'search',
  PAGINATION = 'pagination',
  SORT = 'sort',
  FILTER = 'filter',
  CLEAR_FILTER = 'clear-filter',
  CLEAR_ALL_FILTERS = 'clear-all-filters',
  ITEM = 'item',
}

export enum EventControlPipelineTemplateElement {
  SELECT_PIPELINE_TEMPLATE = 'select-pipeline-template',
}

export enum EventControlSearchResultElement {
  VIEW_REFERENCE = 'view-reference',
  VIEW_FILE_SOURCE = 'view-file-source',
  VIEW_DOC_SOURCE = 'view-doc-source',
}

export enum EventControlStudioElement {
  COMPONENT_STUDIO = 'component',
  OPEN_DOWNLOAD_MODAL_STUDIO = 'open-download-modal',
  COPY_CODE_STUDIO = 'copy-code',
  DOWNLOAD_CODE_STUDIO = 'download-code',
  LOGIN = 'login',
  SAVE_PIPELINE = 'save-pipeline',
  RENAME_PIPELINE = 'rename-pipeline',
  DEPLOY_PIPELINE = 'deploy-pipeline',
  UNDEPLOY_PIPELINE = 'undeploy-pipeline',
  DOCUMENTATION_LINK = 'documentation-link',
  DISCORD_LINK = 'discord-link',
  UNDO_STUDIO = 'undo',
  REDO_STUDIO = 'redo',
}

export enum EventControlIndexFilesElement {
  OPEN_METADATA_FILTERS = 'open-metadata-filters',
  APPLY_METADATA_FILTERS = 'apply-metadata-filters',
  CLEAR_ALL_METADATA_FILTERS = 'clear-all-metadata-filters',
  OPEN_DOCUMENT_PREVIEW = 'open-document-preview',
  CLOSE_DOCUMENT_PREVIEW = 'close-document-preview',
  NEXT_FILE_CLICK = 'next-file-click',
  PREVIOUS_FILE_CLICK = 'previous-file-click',
  RETRY_INDEXING = 'retry-indexing',
  DOCUMENT_PREVIEW_TAB_CHANGE = 'document-preview-tab-change',
  OPEN_METADATA_MODAL = 'open-metadata-modal',
  CLOSE_METADATA_MODAL = 'close-metadata-modal',
  COPY_ERROR_BUTTON = 'copy-error-button',
}

export enum EventControlApiKeysElement {
  COPY_KEY = 'copied-new-key',
  REVOKE_KEY = 'revoke-api-token',
  SAVE_KEY = 'save-api-token',
}

export enum EventControlRolesElement {
  CREATE_ROLE = 'create-role',
  UPDATE_ROLE = 'update-role',
  DELETE_ROLE = 'delete-role',
}
